var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25175 1.75195H2.33525C2.01311 1.75195 1.75195 2.01311 1.75195 2.33525V5.25175C1.75195 5.57391 2.01311 5.83505 2.33525 5.83505H5.25175C5.57391 5.83505 5.83505 5.57391 5.83505 5.25175V2.33525C5.83505 2.01311 5.57391 1.75195 5.25175 1.75195Z",
    stroke: "current",
    strokeWidth: 1.31499,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25175 8.16992H2.33525C2.01311 8.16992 1.75195 8.43107 1.75195 8.75322V11.6697C1.75195 11.9919 2.01311 12.253 2.33525 12.253H5.25175C5.57391 12.253 5.83505 11.9919 5.83505 11.6697V8.75322C5.83505 8.43107 5.57391 8.16992 5.25175 8.16992Z",
    stroke: "current",
    strokeWidth: 1.31499,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6697 1.75195H8.75322C8.43107 1.75195 8.16992 2.01311 8.16992 2.33525V5.25175C8.16992 5.57391 8.43107 5.83505 8.75322 5.83505H11.6697C11.9919 5.83505 12.253 5.57391 12.253 5.25175V2.33525C12.253 2.01311 11.9919 1.75195 11.6697 1.75195Z",
    stroke: "current",
    strokeWidth: 1.31499,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6678 8.16797H8.75127C8.42911 8.16797 8.16797 8.42911 8.16797 8.75127V11.6678C8.16797 11.9899 8.42911 12.2511 8.75127 12.2511H11.6678C11.9899 12.2511 12.2511 11.9899 12.2511 11.6678V8.75127C12.2511 8.42911 11.9899 8.16797 11.6678 8.16797Z",
    stroke: "current",
    strokeWidth: 1.31499,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.e83a8ceede0ac44145019d8e0306c3da.svg";
export { ForwardRef as ReactComponent };